import axios from "../../../common/config/axios";
import * as types from "./types";

export const getCountryDropdown = (data) => (dispatch) => {
    axios.get("country_dropdown")
    .then((res) => {
        dispatch({
            type: types.COUNTRY_DROPDOWN,
            payload: res.data
        });
    })
    .catch((err) => {
        dispatch({
            type: types.COUNTRY_DROPDOWN,
            payload: []
        });
    });
};